import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  LayoutDashboard, Users, Megaphone, Inbox, Wrench, Tag, HelpCircle,
  Star, FileText, Settings, ScrollText, LogOut, Youtube, Menu, X, ShieldCheck,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/leads", label: "Leads / CRM", icon: Users },
  { to: "/admin/campaigns", label: "Campaigns", icon: Megaphone },
  { to: "/admin/inbox", label: "Inbox & Users", icon: Inbox },
  { to: "/admin/services", label: "Services", icon: Wrench },
  { to: "/admin/pricing", label: "Pricing", icon: Tag },
  { to: "/admin/faqs", label: "FAQs", icon: HelpCircle },
  { to: "/admin/testimonials", label: "Testimonials", icon: Star },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/settings", label: "Settings", icon: Settings },
  { to: "/admin/audit", label: "Audit Logs", icon: ScrollText },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex">
      {/* Sidebar */}
      <aside className={`fixed lg:sticky top-0 z-40 h-screen w-64 shrink-0 bg-slate-900 border-r border-white/10 flex flex-col transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="h-16 flex items-center justify-between px-5 border-b border-white/10">
          <Link to="/" className="flex items-center gap-2 font-display font-extrabold"><span className="grid place-items-center w-8 h-8 rounded-lg bg-primary"><Youtube className="w-5 h-5" /></span> NewStarAds</Link>
          <button className="lg:hidden" onClick={() => setOpen(false)}><X className="w-5 h-5" /></button>
        </div>
        <nav className="flex-1 overflow-y-auto p-3 space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)}
              data-testid={`admin-nav-${n.label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-primary text-white" : "text-slate-400 hover:text-white hover:bg-white/5"}`}>
              <n.icon className="w-4 h-4" strokeWidth={1.5} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="px-3 py-2 text-xs text-slate-500 flex items-center gap-1.5"><ShieldCheck className="w-3.5 h-3.5" /> {user?.email}</div>
          <button onClick={() => { logout(); nav("/"); }} data-testid="admin-logout" className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium text-slate-400 hover:text-white hover:bg-white/5"><LogOut className="w-4 h-4" /> Logout</button>
        </div>
      </aside>
      {open && <div className="fixed inset-0 bg-black/50 z-30 lg:hidden" onClick={() => setOpen(false)} />}

      {/* Main */}
      <div className="flex-1 min-w-0">
        <header className="lg:hidden h-16 flex items-center gap-3 px-5 border-b border-white/10 sticky top-0 bg-slate-950 z-20">
          <button onClick={() => setOpen(true)}><Menu className="w-6 h-6" /></button>
          <span className="font-display font-bold">Admin</span>
        </header>
        <div className="p-5 sm:p-8"><Outlet /></div>
      </div>
    </div>
  );
}
